module.exports = __webpack_public_path__ + "static/assets/4692098139c6eb0fc6100262eeb5f09a.ttf";